<template>
    <div v-if="item.enable"
         style="margin-bottom: 1em;"
         :style="{'font-family':item.font,'font-size':item.fontSize}">
        <div style="text-align: center;">
            {{item.text}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocTitle",
        props: {
            item: {},
        }
    }
</script>